module.exports = __webpack_public_path__ + "img/quit_icon.1576f10a.svg";